import ReactGA from 'react-ga';

export function triggerGAEvent(category, action, label) {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  });
}
